export default "__VITE_PUBLIC_ASSET__1bf56150__"